// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c84addea","arrowRight":"d878b3cf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/HistoryNavigation/index.styl
// module id = 5048
// module chunks = 39